import { RecipesCollectionRef } from 'services/firebase';

import RecipeMapper from 'services/mappers/recipes/RecipeMapper';

const read = async (id) => {
  if (!id) throw new Error('id cannot be empty');

  const doc = await RecipesCollectionRef().doc(id).get();

  if (!doc.exists) throw new FirebaseNotFoundError();

  const recipeModel = RecipeMapper.mapFirebaseRefToModel(doc.id, doc.data());

  return recipeModel;
};

export class FirebaseNotFoundError extends Error {}

export default read;
